import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { register } from "../api/authService";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.ionekyc.com";

export default function Register() {
  const [form, setForm] = useState({
    companyName: "",
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [companySelected, setCompanySelected] = useState(false);
  const debounceRef = useRef(null);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setForm({ ...form, companyName: value });
    setCompanySelected(false);
    setShowSuggestions(true);
  };

  useEffect(() => {
    if (form.companyName.trim().length < 2 || companySelected) {
      setSuggestions([]);
      return;
    }
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/clients/search?q=${encodeURIComponent(form.companyName)}`
        );
        const data = await res.json();
        setSuggestions(data);
      } catch (err) {
        console.error("Client search error:", err.message);
      }
    }, 250);
    return () => clearTimeout(debounceRef.current);
  }, [form.companyName, companySelected]);

  const handleSelectCompany = (client) => {
    setForm({ ...form, companyName: client.client_name });
    setCompanySelected(true);
    setShowSuggestions(false);
    setSuggestions([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!companySelected) {
      setError("Please select your company from the suggested list.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await register(form);
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card" style={{ width: 420 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <h2 style={{ margin: 0 }}>Create Client Account</h2>
          <p style={{ color: "#6b7280", fontSize: 13, marginTop: 4 }}>
            Register to access your eKYC dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group qv-autocomplete-wrapper">
            <label>Company name</label>
            <input
              name="companyName"
              value={form.companyName}
              onChange={handleCompanyChange}
              placeholder="Start typing your company name..."
              autoComplete="off"
              required
            />
            {showSuggestions && suggestions.length > 0 && (
              <ul className="qv-suggestions-list">
                {suggestions.map((client) => (
                  <li key={client.client_id} onClick={() => handleSelectCompany(client)}>
                    {client.client_name}
                  </li>
                ))}
              </ul>
            )}
            {form.companyName.length >= 2 && !companySelected && suggestions.length === 0 && (
              <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>
                No matching company found. Contact I-OnAsia if your company isn't listed.
              </p>
            )}
          </div>

          <div className="form-group">
            <label>Full name</label>
            <input name="fullName" value={form.fullName} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Email address</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Confirm password</label>
            <input type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} required />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button type="submit" className="btn-primary" style={{ width: "100%", marginTop: 8 }} disabled={loading}>
            {loading ? "Creating account..." : "Create account"}
          </button>
        </form>

        <p style={{ textAlign: "center", fontSize: 13, marginTop: 20, color: "#6b7280" }}>
          Already have an account?{" "}
          <Link to="/login" style={{ color: "#0b2545", fontWeight: 600 }}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}